import DashboardShell from "@/components/nav/DashboardShell";

export function Documents() {
  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">FILES</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Documents.</h1>
      <div className="border border-line p-10 text-smoke">Attach documents to tasks from the command center. Central library launches next release.</div>
    </DashboardShell>
  );
}

export function Help() {
  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">SUPPORT</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Help.</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
        <div className="border border-line p-6">
          <div className="brand-eyebrow">EMAIL</div>
          <div className="text-white mt-3">help@hired.land</div>
          <div className="text-smoke text-sm mt-1">Business hours reply time: under 2h.</div>
        </div>
        <div className="border border-line p-6">
          <div className="brand-eyebrow">DOCS</div>
          <div className="text-white mt-3">Coming soon</div>
          <div className="text-smoke text-sm mt-1">Full library launching alongside v1.</div>
        </div>
      </div>
    </DashboardShell>
  );
}
